export const getYouTubeEmbedUrl = (url) => {
    // Get the video id from the url
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    const videoId =
        url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];

    // Return embed url with video id
    return `https://www.youtube.com/embed/${videoId}`;
};
